import React from "react";
import { useDispatch } from "react-redux";
import iNotifications from "../../../assets/icons/notifications.svg";

import Form from "../UI/Form";
import FormBlock from "../UI/FormBlock";

import "../../../styles/Dashboard/MyAccount/Notifications.css";
import Loader from "../UI/Loader";
import { changeUserNotifications } from "../../../store/actions/dashboard/user";
import ScreenBlock from "../Screen/ScreenBlock";

const Notifications = (props) => {
  const { USER } = props;
  const dispatch = useDispatch();

  return (
    <ScreenBlock title="Notifications" img={iNotifications}>
      <div className="Screen_Form Notifications">
        {USER?.notifications ? (
          <Form>
            <FormBlock title="Notify me via email for">
              {USER.notifications.map((notification) => {
                const getNotificationName = (name) => {
                  switch (name) {
                    case "New roundtrip published":
                      return "Summary of new roundtrips";
                    case "New tender published":
                      return "Summary of new spotloads";
                      default:
                      return name;
                  }
                }
                return (
                  <div className="toggle-wrapper" key={notification._id}>
                    <label htmlFor={getNotificationName(notification.name)}>
                      {getNotificationName(notification.name)}
                      <input
                        type="checkbox"
                        id={getNotificationName(notification.name)}
                        name={getNotificationName(notification.name)}
                        defaultChecked={notification.value}
                        onChange={(e) =>
                          dispatch(
                            changeUserNotifications(
                              notification._id,
                              e.target.checked
                            )
                          )
                        }
                      />
                      <div className="toggler"></div>
                    </label>
                  </div>
                );
              })}
            </FormBlock>
          </Form>
        ) : (
          <Loader />
        )}
      </div>
    </ScreenBlock>
  );
};
export default Notifications;
